/**
 * Built-in effect `fisheye` (W2-01b; P§5.2): radial lens distortion around the centre of the screen.
 * Reimplemented from the behaviour (badged approximate).
 *
 * Distances are measured with the screen's aspect ratio (circles stay round) and normalised so 1 is a corner. A
 * pixel at normalised radius rho reads the screen at rho * (1 - power * (1 - rho^2)): positive `power` magnifies the
 * centre (fisheye bulge), negative `power` pinches it (barrel), and the corners never move, so the frame stays filled.
 */

import { m } from './builtinFx.messages';
import { defineBuiltin, SAMPLE_SCREEN } from './shared';

export const fisheye = defineBuiltin({
  name: 'fisheye',
  label: { key: m.fisheye },
  description: { key: m.fisheyeDesc },
  inputs: ['screenSize'],
  uniforms: [{ name: 'power', type: 'float', default: -0.1, min: -1, max: 1, label: { key: m.fisheyePower } }],
  helpers: [SAMPLE_SCREEN],
  main: `
void main() {
  vec2 aspect = vec2(screenSize.x / max(screenSize.y, 1.0), 1.0);
  vec2 p = (uv - vec2(0.5)) * aspect;
  float maxR = 0.5 * length(aspect);
  float rho = length(p) / maxR;
  float s = 1.0 - power * (1.0 - rho * rho);
  gl_FragColor = sampleScreen(p * s / aspect + vec2(0.5));
}`,
});
